import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const Create1 = createAsyncThunk(
  "student/auth/registration1",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.College.Registration1, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create2 = createAsyncThunk(
  "student/auth/registration2",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.College.Registration2, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create3 = createAsyncThunk(
  "student/auth/registration3",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.College.Registration3, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create4 = createAsyncThunk(
  "student/auth/registration4",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.College.Registration4, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create5 = createAsyncThunk(
  "student/auth/registration5",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.College.Registration5, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ===== GET / FETCH =====
export const GetRegistration1 = createAsyncThunk(
  "student/auth/get-registration1",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.College.GetRegistration1}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ===== SLICE =====
export const Slice = createSlice({
  name: "studentregistration",
  initialState: {
    data: [],

    status: IDS.SLICESTATUS.Idle,
    error: null,

    getUserData1: null,
    getUserData2: null,
    getUserData3: null,
    getUserData4: null,
    getUserData5: null,

    getUserStatus1: IDS.SLICESTATUS.Idle,
    getUserStatus2: IDS.SLICESTATUS.Idle,
    getUserStatus3: IDS.SLICESTATUS.Idle,
    getUserStatus4: IDS.SLICESTATUS.Idle,
    getUserStatus5: IDS.SLICESTATUS.Idle,

    getUserError1: null,
    getUserError2: null,
    getUserError3: null,
    getUserError4: null,
    getUserError5: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ===== REGISTRATION 1 =====
      .addCase(Create1.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create1.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create1.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetRegistration1.pending, (state) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration1.fulfilled, (state, action) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Succeeded;
        state.getUserData1 = action.payload.data;
      })
      .addCase(GetRegistration1.rejected, (state, action) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Failed;
        state.getUserError1 = action.payload;
      })

      // ===== REGISTRATION 2 =====
      .addCase(Create2.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create2.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create2.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // ===== REGISTRATION 3 =====
      .addCase(Create3.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create3.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create3.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // ===== REGISTRATION 4 =====
      .addCase(Create4.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create4.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create4.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // ===== REGISTRATION 5 =====
      .addCase(Create5.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create5.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create5.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
